import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const ErrorPage503 = ({ setScreenNumber }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div className={styles.headContainer}>
        <HeadContainer setScreenNumber={setScreenNumber} telegramOnly />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>503</p>
        <p className={styles.description}>
          Упс...<br></br>
          Сервіс тимчасово недоступний.<br></br>
          Спробуй, будь ласка, пізніше.
        </p>
      </div>
      <button onClick={() => setScreenNumber(1)}>Повернутися на головну</button>
    </div>
  );
};

export default ErrorPage503;
